// Add tabID to a list in localStorage
export const addTabId = (tabId: string) => {
  const allTabs = JSON.parse(localStorage.getItem('allTabs') || '[]');
  allTabs.push(tabId);
  localStorage.setItem('allTabs', JSON.stringify(allTabs));
  return allTabs.length;
};

// Remove tabID from the list in localStorage
export const removeTabId = (tabId: string) => {
  const allTabs = JSON.parse(localStorage.getItem('allTabs') || '[]');
  const index = allTabs.indexOf(tabId);
  if (index > -1) {
    allTabs.splice(index, 1);
  }
  localStorage.setItem('allTabs', JSON.stringify(allTabs));
  return allTabs.length;
};

// Monitor changes in the list
export const handleStorageChange = (e) => {
  if (e.key === 'allTabs') {
    const tabsList = JSON.parse(e.newValue);
    if (tabsList.length > 1) {
      console.log('Multiple tabs detected!');
    }
  }
};
